// extracted by mini-css-extract-plugin
export var quillEditor = "_jz-1";
export var variable = "_jz-0";